import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { getGetSingleConditionValue } from '../../../_helpers/singleConditionValue'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import { useInterpolations } from '../../../../../../utils/interpolations/interpolations'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import InputWithInterpolations from '../../../../../../packages/kiti-editor/components/input/InputWithInterpolations'
import Modal from '../../../../../../components/structure/Modal'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'

const EmailSentence = () => {
  const [open, setOpen] = React.useState()
  const { form } = useFormState()

  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const interpolations = useInterpolations(form.entity, checklistId)
  const interpolationGallery = interpolations.filter(i => i.type === 'gallery')
  return (
    <>
      <Text size="h2">de</Text>
      <EditableSentence
        label={form.payload?.subject || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Grid paddingGutter={0.5} wrap direction="column-reverse">
          <Col width="100%">
            <FormItem
              label="Mensagem"
              path={['payload', 'content']}
              Input={InputWithInterpolations}
              interpolations={interpolations}
            />
          </Col>

          <Col width="100%">
            <FormItem
              label="Anexos"
              path={['payload', 'attachments']}
              Input={InputWithInterpolations}
              interpolations={interpolationGallery}
            />
          </Col>

          <Col width="100%">
            <Grid paddingGutter={0.5} wrap>
              <Col width="50%">
                <FormItem
                  label="Assunto"
                  path={['payload', 'subject']}
                  Input={InputWithInterpolations}
                  interpolations={interpolations}
                  singleLine
                />
              </Col>

              <Col width="50%">
                <FormItem
                  label="Email"
                  path={['payload', 'to']}
                  Input={InputWithInterpolations}
                  interpolations={interpolations}
                  singleLine
                />
              </Col>
            </Grid>
          </Col>
        </Grid>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default EmailSentence
